import React from 'react';

import {EmptyStateWrapper} from './AutocompleteListBox.styles';
import {Text} from '../../Text';
import {AutocompleteProps} from '../_types';

const defaultRenderEmptyStateLabel = () => 'No results';

export const AutocompleteEmptyState = ({
  renderEmptyStateLabel = defaultRenderEmptyStateLabel,
}: {
  renderEmptyStateLabel: AutocompleteProps['renderEmptyStateLabel'];
}) => {
  return (
    <EmptyStateWrapper>
      <Text colorVariant="secondary">{renderEmptyStateLabel()}</Text>
    </EmptyStateWrapper>
  );
};
